import axios from 'axios';
import { useAuthStore } from '@/store';
import { value } from 'lodash/seq';

const instance = axios.create({
  baseURL: `${process.env.API_URL}/api/${process.env.API_VERSION}/oligo`,
  withCredentials: true,
});

instance.defaults.paramsSerializer = function (paramObj) {
  const params = new URLSearchParams();
  for (const key in paramObj) {
    if (Array.isArray(paramObj[key])) {
      paramObj[key].forEach(value => {
        params.append(key, value);
      });
    } else if (key === 'since') {
      const timezoneOffset = new Date().getTimezoneOffset() * 60000;
      paramObj[key] = new Date(new Date(paramObj[key]).setHours(0, 0, 0, 0) - timezoneOffset).toISOString().slice(0, -5);
      params.append(key, paramObj[key]);
    } else {
      params.append(key, paramObj[key]);
    }
  }
  return params.toString();
};

const REFRESH_TOKEN_PATH = '/auth/refresh-token';
const EXCLUDE_PATHS = ['/customers/owners/register']

const setAuthorizationHeader = (config, token) => {
  config.headers.Authorization = `Bearer ${token}`;
};

const redirectToLogin = () => {
  const authStore = useAuthStore();
  authStore.handleLogoutCamStudy()
};

const isSkipAuth = (config) => {
  const isAuthApiPath = config.url?.startsWith('/auth');
  const isExcludedPath = EXCLUDE_PATHS.includes(config.url);
  return isAuthApiPath || isExcludedPath;
};

const handleTokenRefresh = async (config, authStore) => {
  console.log('## request refreshing new token', config.url);
  const token = await authStore.refreshAccessToken();
  if (!token) {
    redirectToLogin();
    return Promise.reject(new Error('no access token'));
  }

  setAuthorizationHeader(config, token);
  return config;
};

instance.interceptors.request.use(
  async config => {
    const authStore = useAuthStore();

    if (isSkipAuth(config)) {
      return config;
    }

    const existingToken = authStore.getAccessToken;
    if (existingToken) {
      setAuthorizationHeader(config, existingToken);
      return config;
    }

    if (config.url !== REFRESH_TOKEN_PATH) {
      return handleTokenRefresh(config, authStore);
    }

    return config;
  },
  error => {
    return Promise.reject(error);
  },
);

instance.interceptors.response.use(
  response => {
    return response.data;
  },
  async error => {
    const originRequest = error.config
    const errResponse = error.response
    const authStore = useAuthStore();
    if (!errResponse) {
      console.warn('## Axios error without response:', error);
      return Promise.reject(error);
    }

    console.warn('## Axios error status[%s], message[%s], originRequest[%s]',
      errResponse.status,
      errResponse.data.message,
      originRequest.url
    );
    if (errResponse.status === 401) {
      const errorMessage = errResponse.data.message || '';
      if (errorMessage.includes('Invalid Oligo Token')) {
        const newToken = await authStore.refreshAccessToken();
        if (newToken) {
          originRequest.headers.Authorization = `Bearer ${newToken}`;
          return instance(originRequest);
        } else {
          authStore.handleLogoutCamStudy()
          return Promise.reject(error);
        }
      }
    }

    const $router = window?.$nuxt.$router;
    if($router && errResponse.status === 401 && !$router.currentRoute.name.includes('auth')) {
      authStore.handleLogoutCamStudy()
    }else {
      return Promise.reject(error);
    }
    return Promise.reject(error);
  },
);

export default instance;
